import React from "react";
import BackBtn from "./BackBtn";

export interface HeroPage2Props {
  needsBack?: boolean;
  children?: React.ReactNode;
  bgImage?: string;
  bgSize?: string;
}
const HeroPage2: React.FC<HeroPage2Props> = ({
  needsBack = true,
  children,
  bgImage,
  bgSize,
}) => {
  return (
    <section
      className="py-20 xs:bg-center bg-no-repeat xs:pb-[4rem] pb-[7rem] pt-10 relative"
      style={{
        background: `linear-gradient(90deg, rgba(var(--primary-color-rgb), 0.2) 0%, rgba(var(--primary-color-rgb), 0.2) 100%), url(${
          bgImage || "/images/hero-bg.webp"
        })`,
        backgroundSize: `${bgSize || "contain"}`,
      }}
    >
      <div className="wrapper ">
        {needsBack && (
          <div className="mb-10 sm:left-5 sm:top-5 pb-6  top-10 left-10">
            <BackBtn />
          </div>
        )}
        <div className="">{children}</div>
      </div>
    </section>
  );
};

export default HeroPage2;
